import { Form, Text } from "../../../../components";
import Localization from "../../../../localization";
import { useForm } from "../../../../hooks";
import { Flex } from "antd";

export const CustomerForm = ({ customer = {}, form, renderFormItem, ...props }) => {
  const fields = [
    [
      {
        name: "name",
        label: Localization.general.name_and_surname,
        placeholder: Localization.general.firstLastName,
        rules: [
          {
            required: true,
            message: Localization.feedback.required_name_and_surname,
          },
        ],
      },
      {
        name: "email",
        placeholder: "name@example.com",
        label: Localization.general.email_address,
        rules: [
          {
            type: "email",
            required: true,
            message: Localization.feedback.required_email,
          },
        ],
      },
    ],
    {
      name: "phone",
      label: Localization.general.phone_number,
      rules: [{ type: "phone", required: true }],
      placeholder: Localization.general.phone_number,
    },
    [
      {
        name: "property",
        label: Localization.general.home_name,
        placeholder: Localization.placeholder.home_name,
        rules: [
          {
            required: true,
            message: Localization.feedback.required_home,
          },
        ],
      },
      {
        name: "password",
        label: Localization.general.code_word,
        placeholder: Localization.general.voluntarily,
      },
    ],
    {
      name: "address",
      placeholder: "Stora Nygatan 12",
      label: Localization.general.home_address,
      rules: [
        {
          required: true,
          message: Localization.feedback.required_address,
        },
      ],
    },
    [
      {
        name: "postcode",
        placeholder: "12345",
        label: Localization.general.postcode,
        rules: [
          {
            required: true,
            message: Localization.feedback.required_postcode,
          },
        ],
      },
      {
        name: "city",
        placeholder: "Luleå",
        label: Localization.general.city,
        rules: [
          {
            required: true,
            message: Localization.feedback.required_city,
          },
        ],
      },
    ],
  ];

  // Om vi fått in en renderFormItem → rendera som read-only sammanfattning
  if (renderFormItem) {
    return (
      <Flex vertical gap="1.5rem">
        {fields.map((row, rowIndex) =>
          Array.isArray(row) ? (
            <Flex key={rowIndex} gap="2rem" style={{ width: "100%" }}>
              {row.map((field) => (
                <div key={field.name} style={{ flex: 1 }}>
                  {renderFormItem({
                    label: field.label,
                    value: customer[field.name],
                  })}
                </div>
              ))}
            </Flex>
          ) : (
            <div key={rowIndex} style={{ width: "100%" }}>
              {renderFormItem({
                label: row.label,
                value: customer[row.name],
              })}
            </div>
          )
        )}
      </Flex>
    );
  }

  // Annars rendera som vanligt formulär
  return (
    <Form
      {...props}
      form={form}
      initialValues={customer}
      fields={fields}
    />
  );
};

const Customer = ({ customer = {}, onNext = () => {} }) => {
  const form = useForm();

  return (
    <div>
      <Text
        level={5}
        weight="600"
        type="secondary"
        children={`${Localization.general.step} 1: ${Localization.service_edit_alarm_operator.step1_title}`}
      />
      <Text
        type="secondary"
        className="m-5-t"
        children={Localization.service_edit_alarm_operator.step1_desc}
      />
      <CustomerForm form={form} customer={customer} className="m-30-t" />
      <Form.Submit
        type="primary"
        className="m-30-t"
        title={Localization.general.save_and_cont}
        onClick={async () => {
          try {
            await form.validateFields();
            onNext(
              form.getFieldsValue({
                format: { name: "phone", key: "phone" },
              })
            );
          } catch {}
        }}
      />
    </div>
  );
};

export default Customer;
